
import VueAxios from "vue-axios";
import axios from "axios";
//Vue.use(VueAxios, axios);
//Vue.use(Vuex)
//const this.$store.state.baseapi = "http://127.0.0.1:8000/api/";
export default {
    data() {
      return {
       
      }
    },
  
    created() {
     
    },
  
    methods: {
     
     GET_SISTEMA_PAGOS_MUNICIPIO: async function(context) {




      
      var result =  await axios
        ({
          method: 'GET',
          url: this.$store.state.baseapi+"sistema_pagos_municipios/" ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },








    CREAR_SISTEMA_PAGOS_MUNICIPIO: async function(data) {



      
      var result =  await axios
        ({
          method: 'POST',
          url: this.$store.state.baseapi+"sistema_pagos_municipios/" ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
          //QUITAR COMILLAS SOLO EN DATA 
          idmunicipio:data.idmunicipio,
           
          monto:data.monto,
             poas:data.poas,
             descuento:data.descuento, 
          
     
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },





    EDITAR_SISTEMA_PAGOS_MUNICIPIO: async function(data) {




      
      var result =  await axios
        ({
          method: 'PUT',
          url: this.$store.state.baseapi+"sistema_pagos_municipios/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
            'idmunicipio':data.idmunicipio,
            'monto':data.monto,
               'poas':data.poas,
               'descuento':data.descuento, 
           
              
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },

    ELIMINAR_SISTEMA_PAGOS_MUNICIPIO: async function(data) {




      
      var result =  await axios
        ({
          method: 'delete',
          url: this.$store.state.baseapi+"sistema_pagos_municipios/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },
    },
  }